import i18n from "i18next";
import { initReactI18next } from "react-i18next";

i18n.use(initReactI18next).init({
    resources: {
        en: {
            translation: {
                home: "Home",
                history: "History",
                "History": "History",
                "unique-features": "Unique Features",
                "ritual-services": "Ritual Services",
                "daily-festivals": "Daily Ritual",
                timings: "Temple Timings",
                gallery: "Gallery",
                members: "Temple Members",
                contact: "Contact",

                // Address Lines
                address_line1: "Sri Venkateshwara Perumal Temple",
                address_line2: "Konervedhi shivaji Nagar",
                address_line3: "Secunderabad, Telangana 500003",

                temple_name: "Sri Venkateshwara Perumal Temple",
                estd_1823: "Estd. 1823",
                endowments_dept: "Endowments Department, Govt of Telangana",
                location: "Konervedhi shivaji Nagar Secunderabad, Telangana",
                all_rights_reserved: "All Rights Reserved",
                developed_by: "Developed By",
                history_text: "For more than 202 years, the Sri Venkateshwara Perumal Temple has been a revered spiritual center in Secunderabad. Worshipped by devotees, sages, yogis, and spiritual leaders, the temple is known for fulfilling the wishes of devotees as the divine manifestation of Lord Venkateshwara.\n\nAccording to the stone inscription found within the temple premises, this sacred temple was constructed in 1823, during the rule of the Nizam, by Sri Govinda Mudaliar, who served as a Tahsildar at that time. Recognizing Lord Venkateshwara as the deity of the Kali Yuga, the temple has continued to flourish with growing devotion and worship.\n\nIn 1841, Sir Arcot Swami Mudaliar donated land to the temple and built a sacred pond (Koneru). Since then, the locality came to be known as Koneru Street. Near the pond, the temple originally offered facilities such as rooms dedicated for ritual ceremonies (Apara Karma), including a four-room Dharma Shala and an additional hall for public use.\n\nAn adjoining temple dedicated to Sri Anjaneya Swami also stands within the premises. A Navagraha Mandapam was constructed in June 1997, enhancing the spiritual offerings of the temple. Since the temple was established by Tamil devotees, the name \"Perumal\" (a Tamil word meaning \"God\") became a permanent identity of the temple. Most rituals here are performed according to Tamil Pancharatra Agama traditions.\n\nThe temple worship also follows the devotional lineage of the twelve Alwars, renowned Vaishnavite saints such as Poigai Alwar, Bhoothath Alwar, Pey Alwar, Kulasekhara Alwar, Periyalwar, Nammalwar, and others. Their devotional hymns promoting the greatness of Lord Venkateshwara were composed as the \"Nalayira Divya Prabandham,\" also revered as the Dravida Veda. These twelve Alwars are also honored as presiding spiritual saints in this temple.\n\nThe temple recently celebrated its Jeernodharana Kumbhabhishekam (renovation and consecration ceremony) on 11-04-2025.",

                // Contact Section
                "Contact": "Contact",
                "Address": "Address",
                "Phone": "Phone",
                "Open Map": "Open Map",
                "For pooja bookings and enquiries": "For pooja bookings and enquiries",

                // Gallery Section
                "Gallery": "Gallery",
                "View All Gallery": "View All Gallery",

                // Timings Section
                "Timings": "Temple Timings",
                "Monday": "Monday",
                "Tuesday": "Tuesday",
                "Wednesday": "Wednesday",
                "Thursday": "Thursday",
                "Friday": "Friday",
                "Saturday": "Saturday",
                "Sunday": "Sunday",

                // Coming Soon Modal
                "coming_soon_title": "Coming Soon",
                "coming_soon_message": "This feature will be available soon. Thank you for your patience and devotion.",
                "close": "Close",
                "donation": "Donation",

                "Unique Features": "Unique Features",
                "Specialty of the temple": "Specialty of the Temple",
                unique_title: "Sri Varaha Swami with Bhudevi",
                unique_feature_text: "Sri Varaha Swami is the third incarnation of Lord Sri Narayana. Sri Varaha Swami defeated Hiranyaksha and rescued Bhudevi. Thus, this entire earthly realm became known as Sri Varaha Kshetra, belonging to Him.\n\nIn this unique temple, Sri Varaha Swami appears with Bhudevi and Sri Sudarshana Alwar. Normally, Sri Sudarshana Alwar appears only with Sri Narasimha Swami. Therefore, this temple is considered a place of prayer that provides relief for health, education, marriage, and land-related issues.",
                unique_ritual_title: "Ritual Observance",
                unique_ritual_text: "Devotees should begin an 11-day penance every Wednesday with a Sankalpa (vow) and wearing a Kankana (sacred thread). On the 12th day, which is Sunday, during Rahu Kala (approximately 4:30 PM to 6:00 PM), perform Abhishekam to the Lord and offer Suvarna Pushparchana. Your wishes will be fulfilled with the blessings of the Lord.",
                unique_benefits_title: "Blessings & Benefits",
                benefit_health: "Health & Wellness",
                benefit_education: "Education & Knowledge",
                benefit_marriage: "Marriage & Relationships",
                benefit_land: "Land & Property Matters",
                ritual_day: "Special Observance Day",
                ritual_day_name: "Wednesdays & Sundays",
                book_now: "Book Now",

                // Ritual Services
                "Details of various rituals performed in the presence of the Lord": "Details of Various Rituals Performed in the Presence of the Lord",
                ritual_subtitle: "Seva Offerings and Prices",
                paid_services: "Various Paid Services",
                perpetual_poojas: "Perpetual Poojas (10 Years Only)",
                perpetual_note: "Valid for 10 years only",
                prasadam_items: "Sri Vari Prasadam",
                vehicle_poojas: "Vehicle Poojas",
                various_offerings: "Various Offerings",
                special_note_title: "Special Note",
                tulabharam_note: "Tulabharam (weighing ritual) is arranged as per devotees' request. Devotees can become recipients of the Lord's grace through this seva.",

                ashtottara_archana: "Ashtottara Namarchana",
                sahasranama_archana: "Sahasranama Archana",
                abhishekam: "Abhishekam (with Prasadam)",
                kalyanam: "Kalyanam",
                anjaneya_akupuja: "Anjaneya Swami Akupuja",
                swarna_pushparchana: "Swarna Pushparchana",
                annadanam: "Annadanam",

                perpetual_pooja: "Perpetual Pooja",
                perpetual_prasadam: "Perpetual Prasadam Distribution",
                perpetual_abhishekam: "Perpetual Nija Abhishekam",
                perpetual_kalyanam: "Perpetual Nitya Kalyanam",
                varaha_perpetual: "Varaha Swami Perpetual Pooja",
                anjaneya_perpetual: "Anjaneya Swami Perpetual Pooja",

                pulihora_packet: "Pulihora (1 Packet)",
                rava_kesari_packet: "Rava Kesari (1 Packet)",
                laddu_one: "Laddu (1 Piece)",
                vada_one: "Vada (1 Piece)",

                scooter_pooja: "Scooter Pooja",
                auto_car_lorry: "Auto, Car, Lorry",

                pulihora_kg: "Pulihora (1 Kg)",
                chakkera_pongali_kg: "Chakkera Pongali (1 Kg)",
                dadhyojanam_kg: "Dadhyojanam (1 Kg)",
                katte_pongali_kg: "Katte Pongali (1 Kg)",
                rava_kesari_kg: "Rava Kesari (1 Kg)",
                kheerannam_kg: "Kheerannam (1 Kg)",
                laddu_kg: "Laddu (1 Kg)",
                kadambam_kg: "Kadambam (1 Kg)",
                sundelu_kg: "Sundelu (1 Kg)",
                vada_kg: "Vada (1 Kg)",

                // Daily Festivals
                daily_festivals_title: "Details of Daily Ritual",
                time_5_30_am: "5:30 AM",
                event_suprabhatam: "Suprabhatam",
                time_7_00_am: "7:00 AM",
                event_homam_tiruvaradhana: "Homam, Tiruvaradhana, Tiruppavai Seva",
                time_7_45_am: "7:45 AM",
                event_sattumurai: "Sattumurai Teertha Prasadams, Goshti",
                time_8_30_am: "8:30 AM",
                event_tirucchi_seva: "Tirucchi Seva, Procession & Alwars Divya Prabandham",
                time_10_00_am: "10:00 AM",
                event_tirumanjanam: "Tirumanjanam, Teertha Prasada Goshti",
                time_4_00_pm: "4:00 PM",
                event_homam_nityaradhana: "Homam, Nityaradhana",
                time_7_00_pm: "7:00 PM",
                event_vahana_seva: "Vahana Seva Procession",
                time_9_00_pm: "9:00 PM",
                event_alwars_seva: "Alwars Veda Divya Prabandham, Harathi, Teertha Prasadams, Goshti",
                important_notes: "Important Notes",
                festival_note_1: "Every day when the procession takes place, the Alwars Veda Divya Prabandham Seva Kalam will be held.",
                festival_note_2: "Every day from 6:30 PM onwards, cultural programs will be conducted as per schedule.",
                festival_footer_quote: "Experience the divine atmosphere every day",
            },
        },

        te: {
            translation: {
                home: "హోమ్",
                history: "చరిత్ర",
                "History": "చరిత్ర",
                "unique-features": "ప్రత్యేక విశేషతలు",
                "ritual-services": "కైంకర్యములు",
                "daily-festivals": "నిత్య ఉత్సవాలు",
                timings: "దేవాలయ సమయాలు",
                gallery: "గ్యాలరీ",
                members: "దేవాలయ సభ్యులు",
                contact: "సంప్రదించండి",

                // Address Lines
                address_line1: "శ్రీ వేంకటేశ్వర పెరుమాళ్ దేవాలయం",
                address_line2: "కోనేరువీధి శివాజీ నగర్",
                address_line3: "సికింద్రాబాద్, తెలంగాణ 500003",

                temple_name: "శ్రీ వేంకటేశ్వర పెరుమాళ్ దేవాలయం",
                estd_1823: "స్థాపన. 1823",
                endowments_dept: "దేవాదాయ శాఖ, తెలంగాణ ప్రభుత్వం",
                location: "కోనేరువీధి శివాజీ నగర్, సికింద్రాబాద్, తెలంగాణ",
                all_rights_reserved: "అన్ని హక్కులు రిజర్వ్",
                developed_by: "అభివృద్ధి చేసినది",
                history_text: "గత 202 సంవత్సరములుగా సికింద్రాబాద్ ప్రజలకే కాకుండా అనేకమంది సిద్ధులకు, యోగిపుంగవులకు, మఠాధిపతులకు సకల కోరి కలను తీర్చే ఆరాధ్యదైవంగా శ్రీ వేంకటేశ్వర పెరుమాళ్ దేవస్థానము ప్రసిద్ధి చెందింది. ఈ ఆలయాన్ని 1823 సం.లో నాటి నిజాంప్రభుత్వ హయంలో తహసిల్దారుగా పనిచేసిన శ్రీ గోవింద ముదలియార్ నిర్మించినట్లు దేవాలయ గోడలపై వున్న శిలాఫలకాన్ని బట్టి తెలుస్తుంది. కలియుగ దైవంగా భావిస్తూ భక్తుల నీరాజనాలు అందుకుంటున్న శ్రీ వేంకటేశ్వరస్వామి దినదిన ప్రవర్థమానంగా వెలుగొందుతూవస్తున్న సందర్భములో 1841 సంవత్సరములో సర్ ఆర్కాట్ స్వామి మొదలియార్ కొంత భూమిని ఈ దేవాలయానికి విరాళంగా అందజేసి అందులోనే కోనేరు కూడ నిర్మించారు. అప్పటినుంచి ఈ ప్రాంతం కోనేరు వీధిగా వ్యవహారంలోకి వచ్చింది. శ్రీవరాహ పెరుమాళ్ దేవాలయాలు వున్నవి. కోనేరు ప్రక్కనే ఈ దేవాలయము ఆదినములో బ్రాహ్మణులు అపరకర్మలు, సంవత్సరకములు జరుపుకొనుటకు 4 గదులుగల అపరకర్మ ధర్మశాల మరియు ఇతరులకు ప్రత్యేకముగా ఒక షెడ్డుకూడ కలదు. అనుబంధ దేవాలయమైన శ్రీ ఆంజనేయస్వామి ఆలయ ప్రాంగణములో నవగ్రహ మండపము జూన్ 1997 సంవత్సరములో నిర్మాణము గావించబడినది. తమిళ మొదలియార్ నిర్మిం చడం వల్ల ఈ ఆలయానికి శ్రీ వేంకటేశ్వర పెరుమాళ్ అనే పేరు స్థిరపడిపోయింది. పెరుమాళ్ అనేది తమిళ పదం., తమిళంలో \"పెరుమాళ్\" అనగా \"దేవుడు\" అని అర్థము. ఈ దేవాలయములో ఎక్కువగా తమిళ సాంప్రదాయ పాంచరాత్ర ఆగమము ప్రకారము పూజలు జరుగుతూ వుంటాయి. శ్రీవేంకటేశ్వరస్వామివారి భక్తులైన పన్నెండు మంది ఆళ్వారులుగా ప్రసిద్ధి చెందిన పొయ్యిగయి ఆళ్వార్, భూదత్త ఆళ్వార్, పెయి ఆళ్వార్, మధుర కవి ఆళ్వార్, కులశేఖరుడు, పెరి ఆళ్వార్, నమ్మళ్వార్, తిరుమంగయి, తిరుప్పనాళ్వార్, తిరుమళి షయ్, తొండ అడిపుడి, తదితర వైష్ణవ భక్తులు శ్రీ వేంకటేశ్వరస్వామి ప్రాశస్థ్యాన్ని ప్రజల్లో ప్రచారం చేయడానికి వివిధ భక్తిపాటలను కూర్చి నాలయిర్ దివ్యప్రబందంగా తీర్చిదిద్దారు. దీనినే ద్రావిడ వేదంగా కూడా కొలుస్తారు. ఈ పన్నెండు మంది ఆళ్వారులు కూడా ఈ దేవాలయములో కొలువు దీరి వున్నారు. ఈ దేవాలయము 11-04-2025 రోజున జీర్ణోద్దారణ కుంబాభిషేకం నిర్వహించినారు.",

                // Contact Section
                "Contact": "సంప్రదించండి",
                "Address": "చిరునామా",
                "Phone": "ఫోన్",
                "Open Map": "మ్యాప్ తెరవండి",
                "For pooja bookings and enquiries": "పూజా బుకింగ్‌లు మరియు విచారణల కోసం",

                // Gallery Section
                "Gallery": "గ్యాలరీ",
                "View All Gallery": "మొత్తం గ్యాలరీ చూడండి",

                // Timings Section
                "Timings": "దేవాలయ సమయాలు",
                "Monday": "సోమవారం",
                "Tuesday": "మంగళవారం",
                "Wednesday": "బుధవారం",
                "Thursday": "గురువారం",
                "Friday": "శుక్రవారం",
                "Saturday": "శనివారం",
                "Sunday": "ఆదివారం",

                // Coming Soon Modal
                "coming_soon_title": "త్వరలో వస్తోంది",
                "coming_soon_message": "ఈ సౌకర్యం త్వరలో అందుబాటులో ఉంటుంది. మీ ధైర్యం మరియు భక్తికి ధన్యవాదాలు.",
                "close": "మూసివేయండి",
                "donation": "దానం",

                "Unique Features": "ప్రత్యేక విశేషతలు",
                "Specialty of the temple": "దేవాలయ విశిష్టత",
                unique_title: "భూదేవి సమేత శ్రీ వరాహ స్వామివారు",
                unique_feature_text: "శ్రీశ్రీశ్రీ శ్రీమన్నారాయణ స్వామి వారి మూడవ అవతారం శ్రీ వరాహ స్వామివారు. శ్రీ వరాహ స్వామివారు హిరాణ్యాక్షకుని వధించి శ్రీ భూదేవి అమ్మవారిని రక్షించినారు. అందువలన ఈ భూలోకం అంతయు ఆయనకు చెందినదిగా శ్రీ వరాహ క్షేత్రంగా ప్రసిద్ధిగాంచినది.\n\nఈ ఏకైక దేవాలయములో శ్రీ వరాహ స్వామివారు భూదేవి సమేతముగా శ్రీ సుదర్శనాళ్వార్ల వారితో దర్శనమిస్తున్నారు. సాదారణముగా శ్రీ సుదర్శనాళ్వార్లు కేవలం శ్రీ నరసింహ స్వామివారితోనే దర్శనమిస్తారు. కావున ఈ దేవాలయము ప్రార్థనా స్థలముగా పరిగణించబడి ఆరోగ్యం, విద్య, వివాహం మరియు భూ సంబందించిన ఆటంకమునకు ఉపశనము కలిగించును.",
                unique_ritual_title: "దీక్ష విధానం",
                unique_ritual_text: "భక్తులు ప్రతి బుధవారం రోజున సంకల్పం మరియు కంకణ ధారణం చేసి 11 రోజుల దీక్ష ప్రారంభించాలి. తదుపరి 12వ రోజు అనగా ఆదివారం స్వామివారికి రాహుకాల అభిషేకం (సా॥ 4-30 నుండి 6-00 గం.ల వరకు) మరియు సువర్ణ పుష్పార్చన చేయించిన యెడల తమ కోరికలు స్వామివారి ఆశీర్వచనములతో తీరును.",
                unique_benefits_title: "ఆశీర్వాదాలు & ప్రయోజనాలు",
                benefit_health: "ఆరోగ్యం & శ్రేయస్సు",
                benefit_education: "విద్య & జ్ఞానం",
                benefit_marriage: "వివాహం & సంబంధాలు",
                benefit_land: "భూమి & ఆస్తి విషయాలు",
                ritual_day: "ప్రత్యేక దీక్ష దినం",
                ritual_day_name: "బుధవారం & ఆదివారం",
                book_now: "బుక్ చేసుకోండి",

                // Ritual Services
                "Details of various rituals performed in the presence of the Lord": "స్వామివారి సన్నిదిలో జరుగు వివిధ కైంకర్యముల వివరములు",
                ritual_subtitle: "సేవా విధానం మరియు ధరలు",
                paid_services: "వివిధ అర్జిత సేవలు",
                perpetual_poojas: "శాశ్వత పూజలు (10 సంవత్సరములకు మాత్రమే)",
                perpetual_note: "10 సంవత్సరములకు మాత్రమే",
                prasadam_items: "శ్రీవారి ప్రసాదములు",
                vehicle_poojas: "వాహన పూజలు",
                various_offerings: "వివిధ భోగాలు",
                special_note_title: "గమనిక",
                tulabharam_note: "భక్తుల కోరిక మేర తులాభారము ఏర్పాటు చేయటం అయినది. కనుక భక్తులు ఈ సేవ ద్వారా స్వామివారి కృపకు పాత్రులు కాగలరని మనవి.",

                ashtottara_archana: "అష్టోత్తరనామార్చన",
                sahasranama_archana: "సహస్రనామార్చన",
                abhishekam: "అభిషేకము (ప్రసాదముతో)",
                kalyanam: "కళ్యాణము",
                anjaneya_akupuja: "ఆంజనేయస్వామి ఆకుపూజ",
                swarna_pushparchana: "స్వర్ణ పుష్పార్చన",
                annadanam: "అన్నదానము",

                perpetual_pooja: "శాశ్వత పూజ",
                perpetual_prasadam: "శాశ్వత ప్రసాద వితరణ (గోష్టి)",
                perpetual_abhishekam: "శాశ్వత నిజాభిషేకము",
                perpetual_kalyanam: "శాశ్వత నిత్య కళ్యాణము",
                varaha_perpetual: "వరాహస్వామి శాశ్వత పూజ",
                anjaneya_perpetual: "ఆంజనేయస్వామి శాశ్వత పూజ",

                pulihora_packet: "పులిహోర 1 పాకెట్",
                rava_kesari_packet: "రవ్వకేసరి 1 పాకెట్",
                laddu_one: "లడ్డు 1",
                vada_one: "వడ 1",

                scooter_pooja: "స్కూటర్ పూజ",
                auto_car_lorry: "ఆటో, కారు, లారి",

                pulihora_kg: "పులిహోర 1 కిలో",
                chakkera_pongali_kg: "చక్కర పొంగలి 1 కిలో",
                dadhyojanam_kg: "దధ్యోజనము 1 కిలో",
                katte_pongali_kg: "కట్టె పొంగలి 1 కిలో",
                rava_kesari_kg: "రవ్వకేసరి 1 కిలో",
                kheerannam_kg: "క్షీరాన్నము 1 కిలో",
                laddu_kg: "లడ్డు 1 కిలో",
                kadambam_kg: "కదంబము 1 కిలో",
                sundelu_kg: "శుండెలు 1 కిలో",
                vada_kg: "వడ 1 కిలో",

                // Daily Festivals
                daily_festivals_title: "ప్రతి రోజు జరుగు ఉత్సవ వివరములు",
                time_5_30_am: "ఉదయం 5-30 గం.లకు",
                event_suprabhatam: "సుప్రభాతము",
                time_7_00_am: "ఉదయం 7-00 గం.లకు",
                event_homam_tiruvaradhana: "హోమం, తిరువారాధన, తిరుప్పావై సేవ",
                time_7_45_am: "ఉదయం 7-45 గం.లకు",
                event_sattumurai: "శాత్తుమరై తీర్థప్రసాదములు, గోష్టి",
                time_8_30_am: "ఉదయం 8-30 గం.లకు",
                event_tirucchi_seva: "తిరుచ్చి సేవ, శ్రీ స్వామివారి ఊరేగింపు సేవ & ఆళ్వారుల దివ్యప్రబందం",
                time_10_00_am: "ఉదయం 10-00 గం.లకు",
                event_tirumanjanam: "తిరుమంజనము తీర్ధప్రసాద గోష్టి",
                time_4_00_pm: "సాయంత్రం 4-00 గం.లకు",
                event_homam_nityaradhana: "హోమం, నిత్యారాధన",
                time_7_00_pm: "సాయంత్రం 7-00 గం.లకు",
                event_vahana_seva: "వాహన సేవ ఊరేగింపు",
                time_9_00_pm: "సాయంత్రం 9-00 గం.లకు",
                event_alwars_seva: "ఆళ్వారుల వేద దివ్యప్రబందం, హారతి, తీర్థప్రసాదములు, గోష్టి",
                important_notes: "ముఖ్య గమనికలు",
                festival_note_1: "ప్రతి రోజు సేవ ఊరేగింపు జరిగినపుడు ఆళ్వారుల వేద దివ్యప్రబంద సేవాకాలము జరుగును.",
                festival_note_2: "ప్రతి రోజు సాయంత్రం 6-30 గంల నుండి సాంస్కృతిక కార్యక్రమములు సమయానుకూలముగా జరుపబడును.",
                festival_footer_quote: "ప్రతిరోజూ దైవిక వాతావరణాన్ని అనుభవించండి",
            },
        },

        hi: {
            translation: {
                home: "होम",
                history: "इतिहास",
                "History": "इतिहास",
                "unique-features": "अद्वितीय विशेषताएं",
                "ritual-services": "अनुष्ठान सेवाएं",
                "daily-festivals": "दैनिक उत्सव",
                timings: "मंदिर समय",
                gallery: "गैलरी",
                members: "मंदिर सदस्य",
                contact: "संपर्क करें",

                // Address Lines
                address_line1: "श्री वेंकटेश्वर पेरुमाल मंदिर",
                address_line2: "कोनेरुवीधि शिवाजी नगर",
                address_line3: "सिकंदराबाद, तेलंगाना 500003",

                temple_name: "श्री वेंकटेश्वर पेरुमाल मंदिर",
                estd_1823: "स्थापना. 1823",
                endowments_dept: "धर्मादाय विभाग, तेलंगाना सरकार",
                location: "कोनेरुवीधि शिवाजी नगर, सिकंदराबाद, तेलंगाना",
                all_rights_reserved: "सर्वाधिकार सुरक्षित",
                developed_by: "द्वारा विकसित",
                history_text: "202 वर्षों से अधिक समय से, श्री वेंकटेश्वर पेरुमाल मंदिर सिकंदराबाद में एक पूजनीय आध्यात्मिक केंद्र रहा है। भक्तों, संतों, योगियों और आध्यात्मिक नेताओं द्वारा पूजे जाने वाले इस मंदिर को भगवान वेंकटेश्वर की दिव्य अभिव्यक्ति के रूप में भक्तों की इच्छाओं को पूरा करने के लिए जाना जाता है।\n\nमंदिर परिसर में पाए गए पत्थर के शिलालेख के अनुसार, इस पवित्र मंदिर का निर्माण 1823 में निज़ाम के शासन के दौरान श्री गोविंद मुदलियार द्वारा किया गया था, जो उस समय तहसीलदार के रूप में सेवारत थे। भगवान वेंकटेश्वर को कलियुग के देवता के रूप में मान्यता देते हुए, मंदिर बढ़ती भक्ति और पूजा के साथ फलता-फूलता रहा है।\n\n1841 में, सर अर्कोट स्वामी मुदलियार ने मंदिर को भूमि दान की और एक पवित्र तालाब (कोनेरु) का निर्माण किया। तब से, इस इलाके को कोनेरु स्ट्रीट के नाम से जाना जाने लगा। तालाब के पास, मंदिर ने मूल रूप से अनुष्ठान समारोहों (अपर कर्म) के लिए समर्पित कमरे, चार कमरों वाली धर्मशाला और सार्वजनिक उपयोग के लिए एक अतिरिक्त हॉल जैसी सुविधाएं प्रदान कीं।\n\nश्री आंजनेय स्वामी को समर्पित एक सटा हुआ मंदिर भी परिसर में स्थित है। जून 1997 में एक नवग्रह मंडपम का निर्माण किया गया, जिससे मंदिर की आध्यात्मिक पेशकश बढ़ गई। चूंकि मंदिर की स्थापना तमिल भक्तों द्वारा की गई थी, इसलिए \"पेरुमाल\" (एक तमिल शब्द जिसका अर्थ \"भगवान\" है) नाम मंदिर की स्थायी पहचान बन गया। यहां अधिकांश अनुष्ठान तमिल पांचरात्र आगम परंपराओं के अनुसार किए जाते हैं।\n\nमंदिर की पूजा बारह आलवारों की भक्ति वंशावली का भी पालन करती है, जो प्रसिद्ध वैष्णव संत हैं जैसे पोइगई आलवार, भूतत्त आलवार, पेय आलवार, कुलशेखर आलवार, पेरियालवार, नम्मालवार, और अन्य। भगवान वेंकटेश्वर की महानता को बढ़ावा देने वाले उनके भक्ति भजनों को \"नलायिर दिव्य प्रबंधम\" के रूप में रचा गया था, जिसे द्रविड़ वेद के रूप में भी सम्मानित किया जाता है। इन बारह आलवारों को इस मंदिर में अध्यक्षीय आध्यात्मिक संतों के रूप में भी सम्मानित किया जाता है।\n\nमंदिर ने हाल ही में 11-04-2025 को अपनी जीर्णोद्धार कुंभाभिषेकम (नवीनीकरण और अभिषेक समारोह) मनाई।",

                // Contact Section
                "Contact": "संपर्क करें",
                "Address": "पता",
                "Phone": "फोन",
                "Open Map": "मानचित्र खोलें",
                "For pooja bookings and enquiries": "पूजा बुकिंग और पूछताछ के लिए",

                // Gallery Section
                "Gallery": "गैलरी",
                "View All Gallery": "सभी गैलरी देखें",

                // Timings Section
                "Timings": "मंदिर समय",
                "Monday": "सोमवार",
                "Tuesday": "मंगलवार",
                "Wednesday": "बुधवार",
                "Thursday": "गुरुवार",
                "Friday": "शुक्रवार",
                "Saturday": "शनिवार",
                "Sunday": "रविवार",

                // Coming Soon Modal
                "coming_soon_title": "जल्द ही आ रहा है",
                "coming_soon_message": "यह सुविधा जल्द ही उपलब्ध होगी। आपके धैर्य और भक्ति के लिए धन्यवाद।",
                "close": "बंद करें",
                "donation": "दान",

                "Unique Features": "अद्वितीय विशेषताएं",
                "Specialty of the temple": "मंदिर की विशेषता",
                unique_title: "भूदेवी के साथ श्री वराह स्वामी",
                unique_feature_text: "श्री वराह स्वामी भगवान श्री नारायण का तीसरा अवतार हैं। श्री वराह स्वामी ने हिरण्याक्ष का वध किया और भूदेवी की रक्षा की। इस प्रकार, यह संपूर्ण पृथ्वी लोक उनका बन गया और श्री वराह क्षेत्र के रूप में प्रसिद्ध हुआ।\n\nइस अद्वितीय मंदिर में, श्री वराह स्वामी भूदेवी और श्री सुदर्शन आलवार के साथ दर्शन देते हैं। सामान्यतः, श्री सुदर्शन आलवार केवल श्री नरसिंह स्वामी के साथ ही दर्शन देते हैं। इसलिए, इस मंदिर को एक प्रार्थना स्थल माना जाता है जो स्वास्थ्य, शिक्षा, विवाह और भूमि संबंधी समस्याओं से राहत प्रदान करता है।",
                unique_ritual_title: "दीक्षा विधि",
                unique_ritual_text: "भक्तों को हर बुधवार संकल्प और कंकण धारण करके 11 दिनों की दीक्षा शुरू करनी चाहिए। फिर 12वें दिन अर्थात रविवार को राहु काल (लगभग शाम 4:30 से 6:00 बजे तक) के दौरान भगवान को अभिषेक और सुवर्ण पुष्पार्चन अर्पित करना चाहिए। आपकी मनोकामनाएं भगवान के आशीर्वाद से पूर्ण होंगी।",
                unique_benefits_title: "आशीर्वाद और लाभ",
                benefit_health: "स्वास्थ्य और कल्याण",
                benefit_education: "शिक्षा और ज्ञान",
                benefit_marriage: "विवाह और रिश्ते",
                benefit_land: "भूमि और संपत्ति मामले",
                ritual_day: "विशेष दीक्षा दिवस",
                ritual_day_name: "बुधवार और रविवार",
                book_now: "अभी बुक करें",

                // Ritual Services
                "Details of various rituals performed in the presence of the Lord": "भगवान की उपस्थिति में किए जाने वाले विभिन्न अनुष्ठानों का विवरण",
                ritual_subtitle: "सेवा सुविधाएं और मूल्य",
                paid_services: "विभिन्न भुगतान सेवाएं",
                perpetual_poojas: "शाश्वत पूजा (केवल 10 वर्षों के लिए)",
                perpetual_note: "केवल 10 वर्षों के लिए मान्य",
                prasadam_items: "श्री हरि प्रसाद",
                vehicle_poojas: "वाहन पूजा",
                various_offerings: "विभिन्न भेंट",
                special_note_title: "विशेष नोट",
                tulabharam_note: "तुलाभारम (तौल अनुष्ठान) भक्तों के अनुरोध के अनुसार व्यवस्थित किया जाता है। भक्त इस सेवा के माध्यम से भगवान की कृपा के पात्र बन सकते हैं।",

                ashtottara_archana: "अष्टोत्तर नामार्चन",
                sahasranama_archana: "सहस्रनाम अर्चना",
                abhishekam: "अभिषेकम (प्रसाद के साथ)",
                kalyanam: "कल्याणम",
                anjaneya_akupuja: "आंजनेय स्वामी आकुपूजा",
                swarna_pushparchana: "स्वर्ण पुष्पार्चन",
                annadanam: "अन्नदानम",

                perpetual_pooja: "शाश्वत पूजा",
                perpetual_prasadam: "शाश्वत प्रसाद वितरण",
                perpetual_abhishekam: "शाश्वत निज अभिषेकम",
                perpetual_kalyanam: "शाश्वत नित्य कल्याणम",
                varaha_perpetual: "वराह स्वामी शाश्वत पूजा",
                anjaneya_perpetual: "आंजनेय स्वामी शाश्वत पूजा",

                pulihora_packet: "पुलिहोरा (1 पैकेट)",
                rava_kesari_packet: "रवा केसरी (1 पैकेट)",
                laddu_one: "लड्डू (1 पीस)",
                vada_one: "वड़ा (1 पीस)",

                scooter_pooja: "स्कूटर पूजा",
                auto_car_lorry: "ऑटो, कार, लॉरी",

                pulihora_kg: "पुलिहोरा (1 किलो)",
                chakkera_pongali_kg: "चक्कर पोंगली (1 किलो)",
                dadhyojanam_kg: "दध्योजनम (1 किलो)",
                katte_pongali_kg: "कट्टे पोंगली (1 किलो)",
                rava_kesari_kg: "रवा केसरी (1 किलो)",
                kheerannam_kg: "खीरान्नम (1 किलो)",
                laddu_kg: "लड्डू (1 किलो)",
                kadambam_kg: "कदंबम (1 किलो)",
                sundelu_kg: "शुंडेलु (1 किलो)",
                vada_kg: "वड़ा (1 किलो)",

                // Daily Festivals
                daily_festivals_title: "प्रतिदिन होने वाले उत्सवों का विवरण",
                time_5_30_am: "सुबह 5:30 बजे",
                event_suprabhatam: "सुप्रभातम",
                time_7_00_am: "सुबह 7:00 बजे",
                event_homam_tiruvaradhana: "होमम, तिरुवाराधना, तिरुप्पवाई सेवा",
                time_7_45_am: "सुबह 7:45 बजे",
                event_sattumurai: "सात्तुमुराई तीर्थ प्रसादम, गोष्ठी",
                time_8_30_am: "सुबह 8:30 बजे",
                event_tirucchi_seva: "तिरुच्ची सेवा, श्री स्वामी जी की शोभायात्रा और आलवारों का दिव्य प्रबंधम",
                time_10_00_am: "सुबह 10:00 बजे",
                event_tirumanjanam: "तिरुमंजनम, तीर्थ प्रसाद गोष्ठी",
                time_4_00_pm: "शाम 4:00 बजे",
                event_homam_nityaradhana: "होमम, नित्याराधना",
                time_7_00_pm: "शाम 7:00 बजे",
                event_vahana_seva: "वाहन सेवा शोभायात्रा",
                time_9_00_pm: "रात 9:00 बजे",
                event_alwars_seva: "आलवारों का वेद दिव्य प्रबंधम, आरती, तीर्थ प्रसादम, गोष्ठी",
                important_notes: "महत्वपूर्ण नोट",
                festival_note_1: "हर दिन जब शोभायात्रा निकलती है, तो आलवारों का वेद दिव्य प्रबंधम सेवा काल आयोजित किया जाएगा।",
                festival_note_2: "हर दिन शाम 6:30 बजे से सांस्कृतिक कार्यक्रम निर्धारित समय के अनुसार आयोजित किए जाएंगे।",
                festival_footer_quote: "हर दिन दिव्य वातावरण का अनुभव करें",
            },
        },
    },

    lng: "en", // default language
    fallbackLng: "en",
    interpolation: { escapeValue: false },
});

export default i18n;
